import { Checkbox } from '@design-system';
import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';

import { DetailsCard } from '../types';
import { SavedCardCard } from './SavedCardCard';

export type PaymentCardSectionProps = {
  selectedCard?: DetailsCard;
  /** Stripe card Elements, injected by the wrapper. */
  cardFields: ReactNode;
  /** Stripe billing `AddressElement`, shown when billing differs from shipping. */
  billingAddressFields?: ReactNode;
  billingSameAsShipping: boolean;
  saveCard: boolean;
  onBillingSameAsShippingChange: (billingSameAsShipping: boolean) => void;
  onSaveCardChange: (saveCard: boolean) => void;
  onEdit: () => void;
};

export const PaymentCardSection = ({
  billingAddressFields,
  billingSameAsShipping,
  cardFields,
  onBillingSameAsShippingChange,
  onEdit,
  onSaveCardChange,
  saveCard,
  selectedCard,
}: PaymentCardSectionProps) => {
  const { t } = useTranslation('checkout');

  return (
    <section className="flex flex-col gap-3">
      <h3 className="font-bold">{t('details.paymentCard.title')}</h3>

      {selectedCard ? (
        <SavedCardCard
          card={selectedCard}
          editLabel={t('details.paymentCard.edit')}
          onEdit={onEdit}
        />
      ) : (
        <>
          {cardFields}

          <Checkbox
            checked={billingSameAsShipping}
            id="details-billing-same-as-shipping"
            label={t('details.paymentCard.billingSameAsShipping')}
            name="details-billing-same-as-shipping"
            onChange={(e) =>
              onBillingSameAsShippingChange(e.currentTarget.checked)
            }
            type="checkbox"
          />

          {!billingSameAsShipping && billingAddressFields}

          <Checkbox
            checked={saveCard}
            id="details-save-card"
            label={t('details.paymentCard.save')}
            name="details-save-card"
            onChange={(e) => onSaveCardChange(e.currentTarget.checked)}
            type="checkbox"
          />
        </>
      )}
    </section>
  );
};
